import axios from 'axios';
import { FLEX_HISTORY } from '../endpoints';

export type FlexHistoryValue = {
  id: number;
  startTime: string;
  endTime: string;
  deleteReason?: string;
  request: {
    requestId: string;
    costCenter: {
      name: string;
    };
    date: string;
    function: {
      description: string;
    };
  };
  duty: {
    code: string;
  };
  dutyLine: {
    employee: {
      nameCompound: string;
      employeeFunctionDescription: string;
      id: number;
    };
  };
};

type Filters = {
  startDate: string;
  endDate: string;
  brIds?: number[] | null;
  clusterId?: number | null;
  poolId?: number | null;
  connectedEmployee?: number;
  reason?: string;
  functionId?: number;
  agencyIds?: number[];
};

export const getFlexHistoryValues = (
  startDate: string,
  endDate: string,
  brIds?: number[] | null,
  clusterId?: number | null,
  poolId?: number | null,
  employeeId?: number | null,
  requestReason?: string | null,
  functionId?: number | null,
  agencyId?: number[] | null,
  page = 0,
  pageSize = 25
) => {
  const filters: Filters = {
    startDate,
    endDate,
    ...(brIds && brIds.length > 0 ? { brIds } : {}),
    clusterId:
      clusterId !== null && clusterId !== undefined ? clusterId : undefined,
    poolId: poolId !== null && poolId !== undefined ? poolId : undefined,
    connectedEmployee:
      employeeId !== null && employeeId !== undefined ? employeeId : undefined,
    reason:
      requestReason !== null && requestReason !== undefined
        ? requestReason
        : undefined,
    functionId:
      functionId !== null && functionId !== undefined ? functionId : undefined
  };

  if (agencyId !== null && agencyId !== undefined && agencyId.length > 0) {
    filters.agencyIds = agencyId;
  }

  const cleanedFilters = Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== undefined)
  );

  const encodedFilters = encodeURIComponent(JSON.stringify(cleanedFilters));

  // Calculate the range
  const rangeStart = page * pageSize;
  const rangeEnd = rangeStart + pageSize - 1;

  return axios.get<FlexHistoryValue[]>(
    `${FLEX_HISTORY}?filters=${encodedFilters}`,
    {
      headers: {
        Range: `items=${rangeStart}-${rangeEnd}` // Add range in the headers
      }
    }
  );
};

export type FlexHistoryRequest = {
  id: number;
  durationInMillis: number;
  startTime: string;
  endTime: string;
  name: string;
  deleteReason: string;
  taskDefinitionKey: string;
  assignee: string;
  employeeId: number;
  workAgreementId: number;
  performedAction: string;
};

export const getFlexRequestHistory = (processInstanceId: string) =>
  axios.get<FlexHistoryRequest[]>(`${FLEX_HISTORY}/${processInstanceId}`);
